module.exports = __webpack_public_path__ + "img/freshworkslogo.ac8f48a6.svg";